;(function () {
  angular
    .module('contrast.animations')
    .animation('.cs-row-move', function ($, $animateCss, $timeout) {
      'ngInject'

      var lastId = 0
      var _cache = {}

      function getId(el) {
        var id = el[0].getAttribute('row-move-id')
        if (!id) {
          id = ++lastId
          el[0].setAttribute('row-move-id', id)
        }
        return id
      }

      function isLeaving(el) {
        var leavingRow = el[0].getAttribute('cs-row-move-leave'),
          totalCount = el[0].getAttribute('cs-row-move-total')
        return leavingRow == 'true' && totalCount != 1
      }

      function isEntering(el) {
        var enteringRow = el[0].getAttribute('cs-row-move-enter'),
          totalCount = el[0].getAttribute('cs-row-move-total')
        return enteringRow == 'true' && totalCount != 1
      }

      function getTargetGroup(el) {
        return el[0].getAttribute('cs-row-move-target')
      }

      function getTarget(groupName) {
        return $('[cs-row-move-enter-target="' + groupName + '"]')
      }

      function getState(id) {
        var state = _cache[id]
        if (!state) {
          state = {}
          _cache[id] = state
        }
        return state
      }

      function getTargetEl(el) {
        var targetGroup = getTargetGroup(el)

        if (targetGroup) {
          return getTarget(targetGroup)
        }
      }

      function generateRunner(closing, state, animator, element, doneFn) {
        return function () {
          state.animating = true
          state.animator = animator
          state.doneFn = doneFn
          animator.start().finally(function () {
            if (state.doneFn === doneFn && closing) {
              element[0].style.position = 'static'
            }
            state.animating = false
            state.animator = undefined
            state.doneFn()
          })
        }
      }

      return {
        leave: function (element, doneFn) {
          if (isLeaving(element)) {
            var target = getTargetEl(element)
            if (!target) {
              return
            }

            var state = getState(getId(element))

            var children = element.children()
            for (var i = 0; i < children.length; i++) {
              var child = children[i],
                childRect = child.getBoundingClientRect()

              child.style.width = childRect.width + 'px'
            }

            var rect = element[0].getBoundingClientRect()
            element[0].style.position = 'fixed'
            element[0].style.left = rect.left + 'px'
            element[0].style.width = rect.width + 'px'

            element[0].setAttribute('cs-row-move-height', rect.height)

            var targetRect = target[0].getBoundingClientRect()

            var duration = Math.abs(rect.top - targetRect.top) / 120
            if (duration < 0.2) {
              duration = 0.2
            }
            element[0].setAttribute('cs-row-move-duration', duration)

            var animator = $animateCss(element, {
              addClass: 'cs-row-move-leaving',
              easing: 'ease-out',
              from: { top: rect.top + 'px' },
              to: { top: targetRect.top + 'px' },
              duration: 1
            })
            if (animator) {
              if (state.animating) {
                state.doneFn = generateRunner(
                  false,
                  state,
                  animator,
                  element,
                  doneFn
                )
                return state.animator.end()
              } else {
                return generateRunner(false, state, animator, element, doneFn)()
              }
            }
          }
          doneFn()
        },
        enter: function (element, doneFn) {
          if (isEntering(element)) {
            var state = getState(getId(element))

            $timeout(function () {
              var leavingEl = $('.cs-row-move-leaving-add')

              if (leavingEl[0]) {
                var duration = leavingEl[0].getAttribute(
                    'cs-row-move-duration'
                  ),
                  height = leavingEl[0].getAttribute('cs-row-move-height')

                var animator = $animateCss(element, {
                  from: { height: '0px' },
                  to: { height: height + 'px' },
                  duration: duration - 0.1
                })
                if (animator) {
                  if (state.animating) {
                    state.doneFn = generateRunner(
                      false,
                      state,
                      animator,
                      element,
                      doneFn
                    )
                    return state.animator.end()
                  } else {
                    return generateRunner(
                      false,
                      state,
                      animator,
                      element,
                      doneFn
                    )()
                  }
                }
              }
              doneFn()
            }, 100)
          } else {
            doneFn()
          }
        }
      }
    })
})()
